/**
 * A helper function to extract a deeply nested field
 * from an object.
 *
 * eg.
 * ```
 * // Standard usage
 * getNestedFieldInObject('a.b.c', {
 *   a: {
 *     b: {
 *       c: 'hello'
 *     }
 *   }
 * }) === 'hello'
 * // Returns undefined if nested object at any
 * // depth is not found.
 * getNestedFieldInObject('a.b.c', {
 *   a: 'unexpected'
 * }) === undefined
 * ```
 *
 * Note: it isn't tested with arrays.
 *
 * @param path {string} period separated path to the
 *                      nested value to retrieve
 * @param obj {Object}  the object to search within
 * @returns {undefined|*} the nested value if it was
 *                        found otherwise undefined
 */
export default (path, obj) => {
  const parts = path.split('.')
  let nestedObj = obj
  for (let part of parts) {
    if (nestedObj == null || !(part in nestedObj)) {
      return undefined
    }
    nestedObj = nestedObj[part]
  }
  return nestedObj
}
